export default __webpack_public_path__ + "static/media/3.6df7e0b7.png";